// extracted by mini-css-extract-plugin
export default {"cls1":"WGc4gACIGFpdoE5qF_Ex","cls2":"c9dcboMomJJXJJqt8VKt WGc4gACIGFpdoE5qF_Ex"};